import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

const LazyRestrictedUserBanner = () =>
  import(/* webpackChunkName: "4-feat-restricted-user-banner" */ './RestrictedUserBanner');

const LoadableRestrictedUserBanner: ComponentType = lazyLoadOnRender({
  loader: LazyRestrictedUserBanner,
});

LoadableRestrictedUserBanner.displayName = 'RestrictedUserBanner';

export default LoadableRestrictedUserBanner;
